import * as React from 'react';
import { Popover } from 'antd';
import { localizedString } from '@locale/index';
export const RequiredSymbol = (props: { content?: string; }) => {

  return <Popover
    content={props.content || <span
    >{localizedString('common_content_required')}</span>}
  >
    <span style={{ color: 'red' }} >*</span>
  </Popover>;
};
